import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  speedBoostLogs: null,
  error: false,
  loading: false,
  added: false,
  edited: false,
  speedBoostDevices: {},
  speedBoostDevicesLoading: false,
  speedBoostDevicesSuccess: false,
  speedBoostDevicesFailure: false
};
const resetSpeedBoostState = (state, action) => {
  return updateObject(state, initialState)
}
const initSpeedBoostLogsStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    speedBoostDevicesFailure: false,
    speedBoostDevicesSuccess: false
  });
};

const setSpeedBoostLogs = (state, action) => {
  // console.log('SET RED SB', action.logsList)
  return updateObject(state, {
    loading: false,
    speedBoostLogs: action.logsList,
    added: false,
    edited: false,
    speedBoostDevicesSuccess: true,
    speedBoostDevicesFailure: false
  });
};


const fetchSpeedBoostLogsFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true,
    speedBoostLogs:[],
    speedBoostDevicesFailure: true,
    speedBoostDevicesSuccess: false
  });
};
const getSpeedBoostCheckLoading = (state, action) => {
  return updateObject(state, {
    speedBoostDevicesLoading: true,
    speedBoostDevicesSuccess: false,
    speedBoostDevicesFailure: false,
    speedBoostDevices: {}
  });
}

const getSpeedBoostCheckSuccess = (state, action) => {
  return updateObject(state, {
    speedBoostDevicesLoading: false,
    speedBoostDevicesSuccess: true,
    speedBoostDevicesFailure: false,
    speedBoostDevices: action.payload
  });
}

const getSpeedBoostCheckFailure = (state, action) => {
  return updateObject(state, {
    speedBoostDevicesLoading: false,
    speedBoostDevicesSuccess: false,
    speedBoostDevicesFailure: true,
    speedBoostDevices: {}
  });
}



const reducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.INIT_SB_LOGS_START:

      // console.log('SET SB START')

      return initSpeedBoostLogsStart(state, action);
    case actionTypes.SET_SB_LOGS:
      // console.log('SET SB INITIATED')
      return setSpeedBoostLogs(state, action);
    case actionTypes.FETCH_SB_LOGS_FAILED:
      return fetchSpeedBoostLogsFailed(state, action);
    case actionTypes.DEVICES_GET_SPEED_BOOST_LOADING:
      return getSpeedBoostCheckLoading(state, action);
    case actionTypes.DEVICES_GET_SPEED_BOOST_SUCCESS:
      return getSpeedBoostCheckSuccess(state, action);
    case actionTypes.DEVICES_GET_SPEED_BOOST_FAILURE:
      return getSpeedBoostCheckFailure(state, action);
    default:
      return state;
  }
};

export default reducer;
